/* eslint-disable */ 
import axios from 'axios'
import { Loading, Dialog } from 'quasar'
import _ from 'lodash'
// import { fancybox } from '../static/js/fancybox/jquery.fancybox.js'

let app
let loadingCount = 0

function hideLoading() {
  loadingCount = loadingCount - 1
  loadingCount = Math.max(loadingCount, 0)
  if (loadingCount === 0 && Loading.isActive) {
    toHideLoading()
  }
}

var toHideLoading = _.debounce(() => {
  Loading.hide()
}, 0)

function showLoading() {
  if (loadingCount === 0 ) {
    Loading.show({
      message: '處理中，請稍待片刻'
    })
  }
  loadingCount = loadingCount + 1
}

let loadFunction = config => {
  // Loading.show({ message: '處理中，請稍待片刻' })
  showLoading()
  return config
}
let finishFunction = response => {
  // Loading.hide()
  hideLoading()
  return response
}
let downloadFinishFunction = response => {
  // Loading.hide()
  hideLoading()
  download(response)
}
const errorFunction = error => {
  // Loading.hide()
  hideLoading()
  if (error.response !== null) {
    // 權限不足
    if (error.response.status.toString() === '401') {
      // Spring boot 授權失敗
      if (error.response.data.message) {
        Dialog.create({
          color: 'primary',
          title: '訊息!',
          // message: error.response.data.message
          message: '此次連線已逾時，請重新登入',
          persistent: true
        }).onOk(() => {
          localStorage.removeItem('fullUserInfo')
          localStorage.removeItem('token')
          window.location.href = '/'
        })
      // 登入授權失敗
      } else {
        Dialog.create({
          title: '錯誤訊息!',
          message: error.response.data
        })
      }
    } else {
      let ex = error.response.data
      Dialog.create({
        title: '錯誤訊息!',
        message: '訊息 ( ' + ex.code + ' ) : ' + ex.message
      })
    }
  }
  return Promise.reject(error)
}

let blobReader = new FileReader()
// This fires after the blob has been read/loaded.
blobReader.addEventListener('loadend', (e) => {
  const text = e.srcElement.result
  var data = JSON.parse(text)
  // console.log(data)
  if (data && !data.isSuccess) {
    app.openDialog({
      title: '提示訊息',
      message: data.message,
      icon: 'fa-exclamation',
      color: '#3399ff',
      btnColor: 'blue',
      cancelText: '確定'
    })
    /*
    Toast.create.negative({
      html: data.errorMessage,
      timeout: 10000
    })
    */
  }
})

let download = response => {
  let filename = ''
  let suggestedFileName = response.headers['x-suggested-filename']
  if (suggestedFileName) {
    filename = decodeURI(suggestedFileName).replace(/\+/g, ' ')
  }
  if (!filename) {
    if (response.data.type === 'application/json') {
      blobReader.readAsText(response.data)
    }
    else {
      app.openDialog({
        title: '提示訊息',
        message: '無資料可匯出',
        icon: 'fa-exclamation',
        color: '#3399ff',
        btnColor: 'blue',
        cancelText: '確定'
      })
      /*
      Toast.create.negative({
        html: '無資料可匯出',
        timeout: 10000
      })
      */
    }
    return
  }
  let blob = response.data

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
    window.navigator.msSaveBlob(blob, filename)
  }
  else {
    let URL = window.URL || window.webkitURL
    let downloadUrl = URL.createObjectURL(blob)

    if (filename) {
      // use HTML5 a[download] attribute to specify filename
      let a = document.createElement('a')
      // safari doesn't support this yet
      if (typeof a.download === 'undefined') {
        window.location = downloadUrl
      }
      else {
        a.href = downloadUrl
        a.download = filename
        document.body.appendChild(a)
        a.click()
      }
    }
    else {
      window.location = downloadUrl
    }
    // cleanup
    setTimeout(() => { URL.revokeObjectURL(downloadUrl) }, 100)
  }
}

// const axiosInstanceApi = axios.create({ baseURL: network.baseAddress + 'api/' })
const axiosInstanceApi = axios.create({ baseURL: 'api/' })
axiosInstanceApi.interceptors.request.use(loadFunction)
axiosInstanceApi.interceptors.response.use(finishFunction, errorFunction)

// const axiosInstanceDownload = axios.create({ baseURL: network.baseAddress + 'api/', responseType: 'blob' })
const axiosInstanceDownload = axios.create({ baseURL: 'api/', responseType: 'blob' })
axiosInstanceDownload.interceptors.request.use(loadFunction)
axiosInstanceDownload.interceptors.response.use(downloadFinishFunction, errorFunction)

let clients = {
  $http: {
    get () {
      return {
        app: val => {
          app = val
        },
        api: axiosInstanceApi,
        download: axiosInstanceDownload
      }
    }
  }
}

export default (Vue) => {
  // console.log('Vue.prototype:' + JSON.stringify(Vue.prototype))
  // console.log('clients:' + JSON.stringify(clients))
  Object.defineProperties(Vue.prototype, clients)
}
